/**
 * Learner API
 *
 * @author minkyoung.park@emcast.com
*/
import httpService from '@/api/httpService';
const mainApi = {
    // 나의 학습목록(get learning list)
    // https://clpapi.tinkeredu.co.kr/learn/degree/category
    fetCategory() {
        return httpService.get(`/learn/degree/category`)
    },

    // 카테고리 그룹(get group category)
    fetchGroupCategory(params) {
        return httpService.get(`/learn/degree/group-category`, params);
    },

    // 나의 학습목록(get learning list)
    // https://clpapi.tinkeredu.co.kr/samsung/star/membership/member/activity
    fetMember() {
        return httpService.get(`/samsung/star/membership/member/activity`)
    },

    // 나의 학습목록(get Recent view)
    // https://clpapi.tinkeredu.co.kr/samsung/star/learn/learner/online/last
    fetchRecent() {
        return httpService.get(`/samsung/star/learn/learner/online/lesson/last`)
    },

    // 나의 학습목록(get new video talk)
    // https://clpapi.tinkeredu.co.kr/samsung/star/learn/learner/online/last?categories=14
    fetchNewVideoTalk() {
        return httpService.get(`/samsung/star/learn/learner/online/last?categories=1`)
    },

    // 나의 학습목록(get Recent Learning)
    // https://clpapi.tinkeredu.co.kr/samsung/star/learn/learner/online/last?notIn=true&categories=39&categories=41&categories=43
    fetchRecentLearning(params) {
        //return httpService.get(`/samsung/star/learn/learner/online/last?notIn=true&categories=1&categories=3&categories=43`)
        return httpService.get(`/samsung/star/learn/learner/online/last?${params}`)
    },

    // 나의 학습목록(get Recent Content)
    // https://clpapi.tinkeredu.co.kr/samsung/star/learn/online/recent?itemCount=5
    fetchRecentContent() {
        return httpService.get(`/samsung/star/learn/learner/online/recent?itemCount=5`)
    },

    fetchNew() {
        //return httpService.get(`/learn/learner/online/new`)
        return httpService.get(`/integrated/content/new`)
    },

    // Recently Viewed
    // params : itemCount(Integer)
    fetchRecentView(params) {
        return httpService.get(`/samsung/star/learn/learner/online/lessons/last`, params);
    },

    // Notice : Boolean
    fetchNotice() {
        return httpService.get(`/board/main/exists`);
    },

    // Articles
    // params : itemCount(integer)
    fetchArticles(params) {
        return httpService.get(`/board/main/articles`, params);
    },

    // Recent Study
    // params : itemCount(integer), category(Long) 카테고리 아이디
    fetchRecentStudy(params) {
        return httpService.get(`/learn/learner/online/recent`, params);
    },

    // Category List
    fetchCategoryList() {
        return httpService.get(`/learn/degree/category`);
    },

    // 신규 강의 목록
    // params : itemCount(number), categories(List<Number>), categoriesNotIn(List<Number>)
    fetchNewStudyList(params) {
        return httpService.get(`/learn/learner/online/recent?itemCount=5${params}`);
    },

    // 배너 목록
    fetchBannerList() {
        return httpService.get(`/campaign?locationType=MAIN_PAGE`);
    },
}

// export const 
export default mainApi;